<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Offer Categories</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fuild">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9">
            <div class="isotope-wrapper">
              <div class="row">
                <div class="box_general padding_bottom">
                  <form
                    autocomplete="off"
                    @submit.prevent="assignOffercategories()"
                    method="post"
                  >
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Discount to be offered in</label>
                          <select
                            v-model="selectedOfferIn"
                            class="form-control"
                            id="exampleFormControlSelect1"
                          >
                            <option value="value">Value</option>
                            <option value="percent">Percent</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Enter offer in percent / amount </label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="offer_value"
                            placeholder="Offer Value"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Select Location </label>
                          <vue-simple-suggest
                            v-model="location"
                            display-attribute="name"
                            value-attribute="url"
                            :list="getSuggestionList"
                            @select="get($event)"
                          ></vue-simple-suggest>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Enter Pincode </label>
                          <input
                            class="form-control"
                            type="number"
                            v-model="pincode"
                            placeholder="Pincode"
                            maxlength="6"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Valid From</label>
                          <date-picker
                            v-model="valid_from"
                            :config="validFromConfig"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Valid Till</label>
                          <date-picker
                            v-model="valid_till"
                            :config="datepickerconfig"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Default Image</label>

                          <div class="form-group">
                            <div v-if="!image">
                              <input
                                type="file"
                                class="form-control"
                                @change="onFileChange"
                              />
                            </div>
                            <div v-else class="show_img">
                              <img :src="image" height="100px" />
                              <button @click="removeImage">Remove image</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label
                            >Short description (max 160 words allowed)</label
                          >
                          <textarea
                            class="form-control"
                            v-model="short_description"
                            @keyup="wordcount"
                            maxlength="160"
                          ></textarea>
                          <i>word count:{{ short_descriptionCount }}</i>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label
                            >Long description (Max 500 words allowed)</label
                          >
                          <!--textarea
                            style="height: 150px"
                            class="form-control"
                            v-model="description"
                          ></textarea-->
                          <ckeditor
                            :editor="editor"
                            v-model="description"
                            :config="editorConfig"
                            @keyup="wordcount2"
                          ></ckeditor>
                          <!-- <i>word count:{{ long_descriptionCount }}</i> -->
                        </div>
                      </div>
                    </div>
                    <!-- /row -->

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <h5>Category</h5>
                          <div class="row">
                            <div
                              class="form-check category col-md-4"
                              v-for="cat in categories"
                              :key="cat.id"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :value="cat.category_id"
                                v-model="category_id"
                              />
                              <label class="form-check-label" for="">{{
                                cat.category
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="pass-info" class="clearfix"></div>
                    <div class="form-group">
                      <span
                        class="alert alert-info"
                        v-show="category_id.length > 0"
                        >Total
                        <label class="alert alert-danger">{{
                          category_id.length
                        }}</label>
                        Offer Listing will be debited from your account after
                        creating this offer</span
                      >
                      <center>
                        <button
                          type="submit"
                          class="btn_1 rounded add_top_30"
                          :disabled="loading"
                        >
                          <span
                            v-show="loading"
                            class="spinner-border spinner-border-sm"
                          ></span>
                          Publish Offer!
                        </button>
                      </center>
                    </div>
                  </form>
                  <div>
                    <!-- <center>
                      <h2>Please Purchase our package to use this service</h2>
                    </center> -->
                  </div>
                </div>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "../services/index.js";
import Frontendlayout from "../layouts/Frontendlayout.vue";
import Sidebar from "../layouts/Sidebar.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import moment from "moment";
/*import $ from "jquery";
$('.numbersOnly').keyup(function () { 
    this.value = this.value.replace(/[^0-9\.]/g,'');
} );*/
export default {
  data() {
    //alert(localStorage.getItem("pincode"));
    return {
      geocodes: [],
      loading: false,
      token: "Bearer " + localStorage.getItem("token"),
      categories: [],
      category_id: [],
      selectedOfferIn: "selectedOfferIn",
      short_descriptionCount: 0,
      long_descriptionCount: 0,
      offer_value: "",
      location: localStorage.getItem("location"),
      pincode: localStorage.getItem("pincode"),
      valid_from: new Date(),
      valid_till: this.frontEndDateFormat(
        new Date(new Date().setDate(new Date().getDate() + 8))
      ),
      validFromConfig: {
        format: "DD/MM/YYYY hh:mm a",
        useCurrent: false,
        minDate: new Date(),
      },
      datepickerconfig: {
        format: "DD/MM/YYYY hh:mm a",
        useCurrent: false,
        minDate: new Date(),
      },

      description: "",
      short_description: "",
      msg: null,
      classAlert: null,
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        height: "500px",
      },

      serviceBalance: 0,
      image: "",
      default_image: null,
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    VueSimpleSuggest,
  },
  beforeMount() {
    this.checkToken();
    this.getOffercategories();
    this.getServiceBalanceReport();
  },

  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    get(value) {
      var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then(function (response) {
          var j = 0;
          response.data.features.forEach(function (feature) {
            if (j === 0) {
              i.push(feature.geometry.coordinates);
            }
            j++;
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      setTimeout(() => {
        this.geocodes = i;
      }, 2000);
    },
    getSuggestionList() {
      var i = [];
      if (this.location.length >= 2) {
        return API.get(
          `https://location.securebrandtech.com/auto/api?q=${this.location}`
        )
          .then(function (response) {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
            return uniq;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
    wordcount(e) {
      this.short_descriptionCount = e.target.value.length;
      //alert(e.target.value.length);
    },
    wordcount2(e) {
      this.long_descriptionCount = e.target.value.length;
    },
    set_offer_in(event) {
      //alert(this.selectedOfferIn);
      this.selectedOfferIn = " target.value: " + event.target.value;
    },
    getServiceBalanceReport() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      const form = new FormData();
      form.append("service", "offers");
      const token = "Bearer " + localStorage.getItem("token");

      API.post("/profile/service_balance_report", form, {
        headers: { Authorization: token },
      }).then((res) => {
        console.log(res.data.messages);
        if (res.data.status == 200 && res.data.data.length > 0) {
          this.serviceBalance = res.data.data[0].balance;
          //alert(this.serviceBalance);
          if (this.serviceBalance <= 0) {
            Toast.fire({
              icon: "error",
              title: "Please Purchase package to use this service",
            });
            this.$router.push("/packages");
          }
        }
        if (this.serviceBalance == 0) {
          this.$router.push("/packages");
        }
      });
    },
    getOffercategories() {
      API.get("vendor/category_by_vendorId", {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          this.categories = res.data.data;
          console.log(this.categories);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    assignOffercategories() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      this.loading = true;
      if (this.category_id == "") {
        this.loading = false;
        //this.$swal("Error", "please select atleast 1 category");
        Toast.fire({
          icon: "Error",
          title: "please select atleast 1 category",
        });
        return false;
      }
      if (this.geocodes.length == 0) {
        Toast.fire({
          icon: "Error",
          title: "Please Select Location List Option ",
        });
        this.loading = false;
        return false;
      }
      const form2 = new FormData();

      form2.append("serviceprice", "offer");

      API.post("/offer/getofferprice", form2, {
        headers: { Authorization: this.token },
      }).then((res) => {
        this.$swal({
          title: "Are you sure!",
          text: res.data,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes proceed to banner ads",
          closeOnConfirm: false,
        }).then((isConfirm) => {
          if (!isConfirm.isConfirmed) {
            this.$router.push("/create-offers/");
            this.loading = false;
            return false;
          } else {
            const form = new FormData();

            //alert(this.selectedOfferIn);
            form.append("category_id", this.category_id);
            form.append("offer_in", this.selectedOfferIn);
            form.append("offer_value", this.offer_value);
            form.append("location", this.location);
            form.append("pincode", this.pincode);
            form.append("valid_till", this.valid_till);
            form.append("valid_from", this.valid_from);
            form.append("description", this.description);
            form.append("short_description", this.short_description);
            form.append("default_img", this.default_image);
            form.append("lat", this.geocodes);
            API.post("/offer/create", form, {
              headers: { Authorization: this.token },
            }).then((res) => {
              console.log(res.data);
              this.loading = false;
              if (res.data.status == 200) {
                Toast.fire({
                  icon: "success",
                  title: res.data.messages,
                });
                this.$router.push("/offer-list");
              } else {
                //var ErrorText = "";
                let error = JSON.stringify(res.data.messages);
                Toast.fire({
                  icon: "error",
                  title: error,
                });
              }
            });
          }
        });
      });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.default_image = files[0];
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.image = "";
    },
  },
};
</script>

<style  scoped>
.category > label {
  margin: 0px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>